export const phoneRegExp = /^\d{10}$/;
export const spaceRegExp = /^\S*$/;
export const onlySpaceRegExp = /^(?![ ]*$).*/;
export const startsWithSpaceRegExp = /^\S/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
